import { FormControl, FormHelperText, Grid, IconButton, InputLabel, List, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link, useNavigate } from 'react-router-dom';

import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../app/store';
import configUrls from '../../../config/configUrls';
import { TipoDocumento } from '../../../types/tipoDocumento/TipoDocumento';
import TxtTipoDocumento from '../../autoComplete/TxtTipoDocumento';
import { Documento } from '../../../types/processo/Documento';
import TxtSetor from '../../autoComplete/TxtSetor';
import { ISsetor, Setor } from '../../../types/setor/Setor';
import { GridDeleteIcon, itIT } from '@mui/x-data-grid';
import { Usuario } from '../../../types/usuario/Usuario';
import TxtUsuario from '../../autoComplete/TxtUsuario';


type Props = {
    data: Documento,
    isdisabled?: boolean,
    isLoading?: boolean,
    handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handletxtTipoDocumentoChange: (newValue: TipoDocumento) => void;
    handleChangeNivelAcesso?: (e: SelectChangeEvent) => void;

    handletxtSetorChange: (setor: Setor) => void;
    setorValueTmp: Setor;
    handleAdicionarSetor: () => void;
    handleExcluirSetor: (setor: Setor) => void;

    handletxtInteressadoChange: (value: Usuario) => void;
    interessadoValueTmp: Usuario;
    handleAdicionarInteressado: () => void;
    handleExcluirInteressado: (value: Usuario) => void;
}

export function ProcessoGerarDocumentoForm({
    data,
    isdisabled = false,
    isLoading = false,
    handleSubmit,
    handleChange,
    handletxtTipoDocumentoChange,
    handleChangeNivelAcesso,

    handletxtSetorChange,
    setorValueTmp,
    handleAdicionarSetor,
    handleExcluirSetor,

    handletxtInteressadoChange,
    interessadoValueTmp,
    handleAdicionarInteressado,
    handleExcluirInteressado,
}: Props) {

    const navigate = useNavigate();
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);



    useEffect(() => {
        if (!processoSelecionado) {
            navigate(configUrls.PROCESSO_LIST_RT);
        }
    }, [processoSelecionado, navigate]);






    return (
        <Box mt={2} p={2} >

            <form onSubmit={handleSubmit} method='POST'>

                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TxtTipoDocumento
                                required
                                value={data.tipoDocumento}
                                handleSearchChange={handletxtTipoDocumentoChange}
                            />
                        </FormControl>
                    </Grid>



                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Nível de Acesso</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={data.nivelAcesso}
                                label="Nível de Acesso"
                                onChange={handleChangeNivelAcesso}
                                required
                                size='small'
                            >
                                <MenuItem value={'SIGILOSO'}>Sigiloso</MenuItem>
                                <MenuItem value={'RESTRITO'}>Restrito</MenuItem>
                                <MenuItem value={'PUBLICO'}>Público</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Nome na Árvore"
                                name="nomeArvore"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.nomeArvore} />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                label="Descrição"
                                name="descricao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.descricao}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                label="Número / Controle Interno"
                                name="numeroInterno"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.numeroInterno}
                            />
                        </FormControl>
                    </Grid>


                    {/* U S U A R I O     I N T E R E S S A D O */}

                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="space-between" gap={2}>
                            <FormControl fullWidth>
                                <TxtUsuario
                                    label="Pessoas Interessadas"
                                    value={interessadoValueTmp}
                                    handleSearchChange={(it) => {
                                        handletxtInteressadoChange(it);

                                    }}
                                />
                            </FormControl>

                            <FormControl>
                                <Button
                                    onClick={handleAdicionarInteressado}
                                    variant="contained"
                                    color="primary"
                                    disabled={isdisabled}
                                    sx={{ minWidth: 'auto', width: 'auto', alignSelf: 'center' }} // Ajusta o tamanho e alinha
                                >
                                    Adicionar
                                </Button>
                            </FormControl>

                        </Box>

                        {data.interessados && data.interessados.length > 0 && (
                            <FormControl fullWidth>
                                <List dense sx={{ border: '2px solid #1976d2', borderRadius: '8px', backgroundColor: "#d3d3d3" }}>
                                    {data.interessados.map((it) => (
                                        <ListItem key={it.id}>
                                            <ListItemText primary={`${it.nome} (${it.cpf})`} />
                                            <ListItemSecondaryAction>
                                                <IconButton edge="end" aria-label="delete" onClick={() => handleExcluirInteressado(it)}>
                                                    <GridDeleteIcon color="secondary" />
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))}
                                </List>
                            </FormControl>
                        )}

                    </Grid>

                    {/* S E T O R E S    D E     D E S T I N O */}

                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="space-between" gap={2}>
                            <FormControl fullWidth>
                                <TxtSetor

                                    value={setorValueTmp}
                                    handleSearchChange={(setor) => {
                                        handletxtSetorChange(setor);

                                    }}
                                />
                            </FormControl>
                            <FormControl>
                                <Button
                                    onClick={handleAdicionarSetor}
                                    variant="contained"
                                    color="primary"
                                    disabled={isdisabled}
                                    sx={{ minWidth: 'auto', width: 'auto', alignSelf: 'center' }} // Ajusta o tamanho e alinha
                                >
                                    Adicionar
                                </Button>
                            </FormControl>
                        </Box>

                        {data.setores && data.setores.length > 0 && (

                            <FormControl fullWidth>
                                <List dense sx={{ border: '2px solid #1976d2', borderRadius: '8px', backgroundColor: "#d3d3d3" }}>
                                    {data.setores.map((it) => {

                                        let descricao: string = "";

                                        if (it.nome) {
                                            descricao = it.nome;
                                        }

                                        if (it.secretaria?.orgao?.abreviatura) {
                                            descricao += " - " + it.secretaria.orgao.abreviatura;
                                        }

                                        if (it.secretaria?.abreviatura) {
                                            descricao += " - " + it.secretaria.abreviatura;
                                        }




                                        return (


                                            <ListItem key={it.id}>
                                                <ListItemText primary={descricao} />
                                                <ListItemSecondaryAction>
                                                    <IconButton edge="end" aria-label="delete" onClick={() => handleExcluirSetor(it)}>
                                                        <GridDeleteIcon color="secondary" />
                                                    </IconButton>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </FormControl>
                        )}

                    </Grid>










                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                id="observacoes-unidade"
                                required
                                label="Observação desta Unidade:"
                                name="observacao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                multiline
                                rows={4}
                                inputProps={{ maxLength: 255 }}
                                value={data.observacao}
                                placeholder="Digite aqui sua observação..."
                            />
                            <FormHelperText>
                                {data.observacao?.length}/255 caracteres
                            </FormHelperText>
                        </FormControl>
                    </Grid>





                    <Grid item xs={12}>
                        <Box display="flex" gap={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                color="secondary"
                                disabled={isdisabled}
                            >
                                Gravar
                            </Button>

                            <Button
                                variant="contained"
                                component={Link}
                                to={`${configUrls.PROCESSO_FORM_VIEW_LK}${processoSelecionado?.id}`} // Concatenando o valor de processoSelecionado
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

            </form>



        </Box >
    )
}